import React, { useContext, useState, useEffect } from "react";
import { Context } from "../../utils/context";
import axios from "axios";
import { BASE_URL } from "../../utils/BaseURL";
import CardComponent from "./CheckoutComponent/CardComponent";
import { Box, Typography } from "@mui/material";
import AddressModal from "../User/UserComponents/AddressModal";
import { enqueueSnackbar } from "notistack";

const Checkout = ({ setCurrent }) => {
  const { cartSubTotal, cartItems, total, newOrder, setNewOrder } =
    useContext(Context);

  const { user } = JSON.parse(localStorage.getItem("user")) || {};
  const [flag, setFlag] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");

  const [userAddresses, setuserAddresses] = useState([]);

  const handleSubmit = async (e) => {
    if (!selectedAddress) {
      return enqueueSnackbar("Please Select Address", { variant: "error" });
    }
    let shipAdd = userAddresses?.find((el) => el?._id == selectedAddress);

    setNewOrder((prev) => ({
      ...prev,
      shipping_address: shipAdd,
    }));

    setCurrent((prev) => prev + 1);
  };
  useEffect(() => {
    axios.get(`${BASE_URL}/address/${user._id}`).then((res) => {
      let addresses = res.data.data;
      if (!addresses.length) {
        enqueueSnackbar(
          "No addresses found, You need to add a delivery address",
          { variant: "warning" }
        );
      }
      setuserAddresses(addresses);
    });
  }, [flag]);

  return (
    <div className="flex flex-col md:flex-row mx-auto max-w-[70%]">
      <div className="py-12 md:w-[70%]">
        <div className="mx-auto bg-white rounded-lg w-full">
          <div>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              mb={"10px"}
            >
              <Typography variant="h6">Select Delivery Address</Typography>
              <AddressModal flag={flag} setFlag={setFlag} />
            </Box>
            <div
              className="w-full"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2,1fr)",
                gap: "10px",
              }}
            >
              {userAddresses &&
                userAddresses.map((el, index) => (
                  <CardComponent
                    key={el?._id + index}
                    id={el?._id}
                    tag={el?.addressType}
                    address={`${el?.address}, ${el?.city} , ${el?.state}`}
                    pincode={el.pincode}
                    number={el?.mobile}
                    selectedAddress={selectedAddress}
                    setSelectedAddress={setSelectedAddress}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>

      <div className="md:w-[35%] px-5 md:ml-4">
        <div className="border-2 md:mt-12 p-5 rounded-lg bg-white">
          <div className="text-l font-bold mb-4 text-center">Your Cart</div>
          <div className="max-h-60 overflow-y-auto">
            {cartItems?.map((item) => (
              <div
                key={item._id}
                className="flex items-center gap-5 flex-start border-b py-4"
              >
                <img
                  src={item.images?.featuredImage?.src}
                  alt={item.name}
                  className="h-16 max-w-20 object-cover rounded"
                />
                <div>
                  <div className="text-md font-bold line-clamp-1">
                    {item.name}
                  </div>
                  <div className="font-bold text-l">₹{item.price}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="flex justify-between items-center border-t py-4">
            <div className="text-l font-bold">SUBTOTAL:</div>
            <div className="text-l text-green-600 font-bold">
              ₹{newOrder?.subtotal || newOrder?.total}
            </div>
          </div>
        </div>

        <button
          // onClick={() => handleIncPage()}
          onClick={() => handleSubmit()}
          className="w-full py-3 mt-6 bg-[#FF8400] text-white font-bold rounded-full hover:bg-blue-600"
        >
          Proceed To Pay
        </button>
      </div>
    </div>
  );
};

export default Checkout;
